module.exports = __webpack_public_path__ + "media/images/top/seminars/top/img_flow02-078c367238a69a83e3a480093dfaa90a.png";